<template>
  <div class="faq">
    <Faq/>
  </div>
</template>

<script>
// @ is an alias to /src
import Faq from '@/components/Faq.vue'

export default {
  name: 'faq',
  components: {
    Faq
  }
}
</script>